import { Alerts } from "../../../../../../utils/Alerts.js";
import { useRPCContext } from "../../../../../../contexts/RPCContext.js";
import { FormBuilderFormRenderer } from "../../../../../FormBuilder/components/FormBuilderFormRenderer/index.js";
import { useState } from "react";
import { FormLayout, Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventInteractive/EventInfoFormBuilder/components/FormBuilderForm.tsx
function EventInfoFormBuilderForm({ event, eventType, onCancel, onComplete }) {
	const [formInput, setFormInput] = useState(event.infoFormInput);
	const [saving, setSaving] = useState(false);
	const { rpcService } = useRPCContext();
	const [formBuilderErrors, setFormBuilderErrors] = useState();
	const handleSave = () => {
		if (!formInput) throw new Error("No form input");
		setSaving(true);
		rpcService.Events.UpdateEvent.v2.call({ event: {
			id: event.id,
			infoFormInput: formInput
		} }).then(() => {
			Alerts.success("Event info updated");
			onComplete();
		}).catch((err) => {
			console.log("Events.UpdateEvent.v2.call() err", err);
			Alerts.error("There was a problem updating the Event info", err.message);
		}).finally(() => setSaving(false));
	};
	const formId = event.infoFormInput?.formId || eventType.formsConfig?.infoFormId;
	if (!formId) return /* @__PURE__ */ jsx("div", {
		className: "text-color-neutral",
		children: "No Info Form configured"
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		children: [saving && /* @__PURE__ */ jsx(Loading, { overlay: true }), /* @__PURE__ */ jsxs(FormLayout, { children: [/* @__PURE__ */ jsx(FormBuilderFormRenderer, {
			formId,
			formValues: formInput?.fields,
			initialValue: formInput?.fields,
			onFormErrorStateChange: setFormBuilderErrors,
			onFormInputChange: setFormInput
		}), /* @__PURE__ */ jsx(FormLayout.Controls, {
			disabled: saving || !!formBuilderErrors,
			onCancel,
			onSave: handleSave,
			submitLabel: "Save"
		})] })]
	});
}
//#endregion
export { EventInfoFormBuilderForm };

//# sourceMappingURL=FormBuilderForm.js.map